import useOnTextSelected from './useOnTextSelected';

export default useOnTextSelected;